import React from 'react';
import { withRouter } from 'react-router-dom';
import SDKLivenessForm from './SDKLivenessForm';


class SDKLivenessEdit extends React.Component {
    constructor(props){
        super(props);
        this.id = props.match.params.id;
    }
    validateFields = (values,config)=>{
        this.form && this.form.validateFields(values,config);
    }

    render(){
        return (
            <div>
                <SDKLivenessForm validateFields={this.validateFields} id={this.id} ref={(form)=>this.form=form}/>
            </div>
        );
    }

}
export default withRouter(SDKLivenessEdit);



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/SDKLivenessEdit.js